import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Contact, CompteContact } from '../../models/contact.model';

@Injectable({ providedIn: 'root' })
export class ContactService {
  private base = `${environment.BASE_URL}/api/contacts`;

  constructor(private http: HttpClient) {}

  getAll(fermeId: number, type?: string): Observable<Contact[]> {
    let params = new HttpParams().set('fermeId', fermeId);
    if (type) params = params.set('type', type);
    return this.http.get<Contact[]>(this.base, { params });
  }

  getById(id: number): Observable<Contact> {
    return this.http.get<Contact>(`${this.base}/${id}`);
  }

  create(dto: Contact): Observable<Contact> {
    return this.http.post<Contact>(this.base, dto);
  }

  update(id: number, dto: Contact): Observable<Contact> {
    return this.http.put<Contact>(`${this.base}/${id}`, dto);
  }

  /** Fiche utilisée par des transactions ou factures : archivée plutôt que supprimée */
  delete(id: number): Observable<{ archive: boolean }> {
    return this.http.delete<{ archive: boolean }>(`${this.base}/${id}`);
  }

  /** Compte complet : ventes, achats, restes dus, paiements, factures, relances */
  compte(id: number): Observable<CompteContact> {
    return this.http.get<CompteContact>(`${this.base}/${id}/compte`);
  }

  getAllAvecArchives(fermeId: number): Observable<Contact[]> {
    return this.http.get<Contact[]>(this.base, { params: new HttpParams().set('fermeId', fermeId).set('archives', 'true') });
  }
}
